import React, { useLayoutEffect } from "react";

import Footer from "../components/footer/footer";
import SathyaSaiMenu from "../components/navbarmenu/navmenu";
import Banner from "../components/banner/banner";
import SSCMKESchedule from "../components/eventschedule/eventschedule";
import BottomBanner from "../components/bottombanner/bottombanner";
import Menucardforallpage from "../components/menucardforallpage/menucardforallpage";
import Calendar from "../components/eventcal/eventcal";

function SSSMKECalendar() {
  useLayoutEffect(() => {
      document.title = 'Sri Sathya Sai Center of Milwaukee Calendar | ssscmke.org';
  }, []);
  return (
    <div className="SSE">
        <SathyaSaiMenu />
        <Banner title="Event Calendar" pic="/images/sse-Banner.png"/>
        <SSCMKESchedule />
        <Calendar />
        <Menucardforallpage page="sse" />
        <BottomBanner />
        <Footer />
    </div>
  );
}
export default SSSMKECalendar;
